export function isNearExpiry(expirationDate: string, thresholdDays: number = 30): boolean {
    const daysUntil = calculateDaysUntilExpiration(expirationDate);
    return daysUntil <= thresholdDays && daysUntil > 0;
}

export function calculateDaysUntilExpiration(expirationDate: string): number {
    return calculateDaysUntilMaturity(expirationDate);
}

export function calculateDaysUntilMaturity(maturityDate: string): number {
    const today = new Date();
    const maturity = new Date(maturityDate);
    const diffTime = maturity.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return Math.max(0, diffDays);
}
